<template>
  <y-block-box title="新增用户" :info="info">
    <template #suffix>
      <span style="color: #9BA6B4;font-size: 12px;">
        共 <span style="font-size: 16px;font-weight: bold;">{{renderData.length}}</span> 人
      </span>
    </template>
    <el-table v-loading="loading" style="height: max-content;min-height: 100%;" :show-header="false" :data="renderData">
      <el-table-column prop="name" label="用户名" width="80px" align="center"></el-table-column>
      <el-table-column prop="team" label="单位" align="center"></el-table-column>
      <el-table-column prop="contact" label="联系方式" align="center"></el-table-column>
      <el-table-column prop="fromText" label="用户来源渠道" width="50px" align="center"></el-table-column>
    </el-table>
  </y-block-box>
</template>

<script>
export default {
  name: "RecentUser",
  data(){
    return{
      renderData: [],
      info:"",
      loading:false,
    }
  },
  mounted() {
    this.queryData();
  },
  methods:{
    async queryData() {
      this.loading = true
      let res = await this.$callApi("board.getRecentUser");
      this.renderData = res.data;
      this.info = res.message;
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/board/components/RecentUser/RecentUser.vue